import React, { useState } from 'react'
import { Form, Button, Col, Row } from 'react-bootstrap';

import './styles.css'


const RegisterFile = (props) => {

    const dateCurrent = new Date();

    let list_count_position = []
    for (let i = 1; i <= 20; i++) {
        list_count_position.push(i)
    }

    const fields = {
        'source_database': ['Aws', 'Server'],
        'bucket_owner': ['Natura', 'Avon', 'Outro'],
        'date_in_file': ['file_name', 'first_line', 'last_line', 'col', 'None'],
        'date_format': ['ddmmyyyy', 'dd_mm_yyyy', 'dd-mm-yyyy', 'dd/mm/yyyy', 'yyyymmdd', 'yyyy_mm_dd', 'yyyy-mm-dd', 'yyyy/mm/dd'],
        'count_in': ['Header', 'Trailer', 'None'],
        'count_position': list_count_position,
        'delimiter': ['\t', '|', ',', ';', 'outro'],
        'file_mask': [],
        'extension': ['csv', 'CSV', 'txt', 'TXT'],
        'ref_dtype': ['oracle', 'postgresql', 'SQLserver', 'None']
    }

    return (
        <div>
            <div className="regFile-btn-back">
                <Button variant="light" onClick={props.handleBack} >Back</Button>
            </div>

            <div className="regTable-container">

                <Form className="regTable-form" >

                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Submitter *</Form.Label>
                                <Form.Control type="text" placeholder="Enter submitter" />
                            </Form.Group>
                        </Col>
                        <Col xs={8} />
                    </Row>

                    <hr />

                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Source *</Form.Label>
                                <Form.Select aria-label="Default select example" >
                                    <option></option>
                                    {fields.source_database.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Bucket owner</Form.Label>
                                <Form.Select aria-label="Default select example" >
                                    <option></option>
                                    {fields.bucket_owner.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                        </Form.Group>
                        </Col>
                    </Row>
                    
                    <hr />

                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>File name *</Form.Label>
                                <Form.Control type="text" placeholder="Enter file name" />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>File path *</Form.Label>
                                <Form.Control type="text" placeholder="Enter file path" />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>File type *</Form.Label>
                                <Form.Select aria-label="Default select example" >
                                    <option></option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Run Schedule (Crontab format) *</Form.Label>
                                <Form.Control type="text" placeholder="Enter run schedule (Crontab format)" />
                        </Form.Group>
                        </Col>
                    </Row>
                    
                    <hr />

                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Date in file *</Form.Label>
                                <Form.Select aria-label="Select date in file" >
                                    <option></option>
                                    {fields.date_in_file.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Date format</Form.Label>
                                <Form.Select aria-label="Select date format" >
                                    <option></option>
                                    {fields.date_format.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Date Column</Form.Label>
                                <Form.Control type="text" placeholder="Enter date column" />
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr />

                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Count in *</Form.Label>
                                <Form.Select aria-label="Select count in" >
                                    <option></option>
                                    {fields.count_in.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Count position</Form.Label>
                                <Form.Select aria-label="Select count position" >
                                    <option></option>
                                    {fields.count_position.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Delimiter *</Form.Label>
                                <Form.Select aria-label="Select delimiter" >
                                    <option></option>
                                    {fields.delimiter.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>File Mask *</Form.Label>
                                <Form.Select aria-label="Select file mask *" >
                                    <option></option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Extension *</Form.Label>
                                <Form.Select aria-label="Select extension" >
                                    <option></option>
                                    {fields.extension.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    <hr />

                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Ref_dtype *</Form.Label>
                                <Form.Select aria-label="Select extension" >
                                    <option></option>
                                    {fields.ref_dtype.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={10} />
                    </Row>

                    <div className="regTable-button">
                        <Button variant="primary" type="submit">
                            Register File
                        </Button>
                    </div>

                    <p className="regTable-mandatory">* Mandatory fields</p>
                </Form>
            </div>
        </div>
    );
}

export default RegisterFile;
